/**
 * To manage states using Redux instead of Zustand,
   uncomment commented codes, then comment Zustand codes
 */

import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/Logo.svg";
import closeIcon from "../../assets/images/close.svg";

import sidebarMenuConfig from "../../router/sidebarMenuConfig";
import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { toggleMenu } from "../../features/uiSlice";
import useStore from "../../store";

const Sidebar = () => {
  // const dispatch = useDispatch();
  // const menuOpen = useSelector((state) => state.ui.menuOpen);
  const { menuOpen, setMenuOpen } = useStore();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const { pathname } = useLocation();
  const [path, setPath] = useState(pathname);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setPath(pathname);
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    document.body.classList.add("menu-open");
    menuOpen
      ? document.body.classList.add("menu-open")
      : document.body.classList.remove("menu-open");

    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [menuOpen]);

  return (
    <aside
      className={`${menuOpen ? "left-0" : "-left-full"} flex flex-col transition-all w-full h-auto fixed z-20 top-0 bottom-0 bg-[linear-gradient(219deg,_#001522,_#002230_50%,_#001522)] md:top-[77px] md:w-[339px] lg:left-0 overflow-auto`}
    >
      <header className="h-[77px] px-[44px] border-b border-[#2B4657] flex items-center justify-between md:hidden">
        <img src={logo} className="min-w-[135px] w-[135px]" alt="Logo" />
        <button onClick={() => setMenuOpen(false)}>
          <img src={closeIcon} className="" alt="Close icon" />
        </button>
      </header>
      <div className="px-[25px] pt-[25px] flex-1">
        <p className="text-[12px] leading-normal font-medium uppercase tracking-[0.1em] text-grey-300 mb-[15px]">
          Navigate
        </p>
        <ul className="flex flex-col gap-2.5">
          {sidebarMenuConfig.map(({ to, label, icon }) => {
            return (
              <li
                className="text-[16px] leading-normal font-medium"
                key={label}
              >
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    isActive ||
                    path
                      .toLowerCase()
                      .includes(label.slice(0, -1).toLowerCase())
                      ? "flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all bg-gradient-to-r from-orange-300 to-orange-200"
                      : "group flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all hover:bg-white hover:text-orange-200"
                  }
                >
                  {icon()}
                  <span>{label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="px-[25px] pt-[50px] flex-1 overflow-y-auto">
        {(userData?.role === "superadmin" || userData?.role === "admin") && (
          <p className="text-[12px] leading-normal font-medium uppercase tracking-[0.1em] text-grey-300 mb-[15px]">
            Administrator
          </p>
        )}
        <ul className="flex flex-col gap-2.5">
          {/* <li className="text-[16px] leading-normal font-medium">
              <NavLink
                to={"/stripe/products"}
                className={({ isActive }) =>
                  isActive
                    ? "flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all bg-gradient-to-r from-orange-300 to-orange-200"
                    : "group flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all hover:bg-white hover:text-orange-200"
                }
              >
                <svg
                  width="15px"
                  height="15px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 4C11.4477 4 11 4.44772 11 5C11 5.35894 11.1884 5.67471 11.4766 5.8524C11.6281 5.94587 11.8062 6 12 6C12.1938 6 12.3719 5.94587 12.5234 5.8524C12.8116 5.67471 13 5.35894 13 5C13 4.44772 12.5523 4 12 4ZM9 5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5C15 5.71445 14.75 6.37013 14.334 6.88471L19.3691 15.0667C19.5728 15.023 19.7839 15 20 15C21.6569 15 23 16.3431 23 18C23 19.6569 21.6569 21 20 21C18.6938 21 17.5825 20.1652 17.1707 19H6.82929C6.41746 20.1652 5.30622 21 4 21C2.34315 21 1 19.6569 1 18C1 16.3431 2.34315 15 4 15C4.21608 15 4.42723 15.023 4.63095 15.0667L9.666 6.88471C9.25004 6.37013 9 5.71445 9 5ZM11.3691 7.93333L6.334 16.1153C6.54576 16.3772 6.71451 16.6758 6.82917 17H17.1708C17.2855 16.6758 17.4542 16.3772 17.666 16.1153L12.6309 7.93333C12.4272 7.97702 12.2161 8 12 8C11.7839 8 11.5728 7.97702 11.3691 7.93333ZM4 17C3.44772 17 3 17.4477 3 18C3 18.5523 3.44772 19 4 19C4.55228 19 5 18.5523 5 18C5 17.6411 4.81156 17.3253 4.52344 17.1476C4.37186 17.0541 4.19378 17 4 17ZM20 17C19.8062 17 19.6281 17.0541 19.4766 17.1476C19.1884 17.3253 19 17.6411 19 18C19 18.5523 19.4477 19 20 19C20.5523 19 21 18.5523 21 18C21 17.4477 20.5523 17 20 17Z"
                      fill="#ffffff"
                      className="group-hover:fill-orange-200 group-[.active]:fill-orange-200"
                    ></path>
                  </g>
                </svg>
                <span>Stripe Products</span>
              </NavLink>
            </li> */}
          {/* <li className="text-[16px] leading-normal font-medium">
              <NavLink
                to={"/stripe/all-subscriptions"}
                className={({ isActive }) =>
                  isActive
                    ? "flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all bg-gradient-to-r from-orange-300 to-orange-200"
                    : "group flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all hover:bg-white hover:text-orange-200"
                }
              >
                <svg
                  width="15px"
                  height="15px"
                  viewBox="0 -8.97 55.248 55.248"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#ffffff"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <g
                      id="Group_18"
                      data-name="Group 18"
                      transform="translate(-999.439 -727.38)"
                    >
                      <path
                        id="Path_46"
                        data-name="Path 46"
                        d="M1050,729.38a2.151,2.151,0,0,0-1.773,3.371l-13.353,9.17-6.3-8.653a2.153,2.153,0,1,0-2.527,0l-6.3,8.653-13.352-9.17a2.151,2.151,0,1,0-1.773.934V762.7H1050V733.685a2.152,2.152,0,1,0,0-4.3Z"
                        fill="#ffffff"
                        stroke="#ffffff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="4"
                        className="group-hover:fill-orange-200 group-[.active]:fill-orange-200"
                      ></path>
                      <line
                        id="Line_27"
                        data-name="Line 27"
                        x2="51.248"
                        transform="translate(1001.439 755.82)"
                        fill="#ffffff"
                        stroke="#ffffff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="4"
                      ></line>
                      <path
                        id="Path_47"
                        data-name="Path 47"
                        d="M1014.5,748a1.978,1.978,0,1,1-1.979-1.978A1.977,1.977,0,0,1,1014.5,748Z"
                        fill="#ffffff"
                        className="group-hover:fill-orange-200 group-[.active]:fill-orange-200"
                      ></path>
                      <path
                        id="Path_48"
                        data-name="Path 48"
                        d="M1029.575,748a1.978,1.978,0,1,1-1.977-1.978A1.978,1.978,0,0,1,1029.575,748Z"
                        fill="#ffffff"
                        className="group-hover:fill-orange-200 group-[.active]:fill-orange-200"
                      ></path>
                      <path
                        id="Path_49"
                        data-name="Path 49"
                        d="M1043.894,748a1.978,1.978,0,1,1-1.978-1.978A1.977,1.977,0,0,1,1043.894,748Z"
                        fill="#ffffff"
                        className="group-hover:fill-orange-200 group-[.active]:fill-orange-200"
                      ></path>
                    </g>
                  </g>
                </svg>
                <span>Stripe Subscriptions</span>
              </NavLink>
            </li> */}

          {(userData?.role === "superadmin" || userData?.role === "admin") && (
            <>
              <li className="text-[16px] leading-normal font-medium">
                <NavLink
                  to={"/stripe/all-users"}
                  className={({ isActive }) =>
                    isActive
                      ? "flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all bg-gradient-to-r from-orange-300 to-orange-200"
                      : "group flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all hover:bg-white hover:text-orange-200"
                  }
                >
                  <svg
                    width="15px"
                    height="15px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M13 20V18C13 15.2386 10.7614 13 8 13C5.23858 13 3 15.2386 3 18V20H13ZM13 20H21V19C21 16.0545 18.7614 14 16 14C14.5867 14 13.3103 14.6255 12.4009 15.6311M11 7C11 8.65685 9.65685 10 8 10C6.34315 10 5 8.65685 5 7C5 5.34315 6.34315 4 8 4C9.65685 4 11 5.34315 11 7ZM18 9C18 10.1046 17.1046 11 16 11C14.8954 11 14 10.1046 14 9C14 7.89543 14.8954 7 16 7C17.1046 7 18 7.89543 18 9Z"
                        stroke="#ffffff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="group-hover:fill-orange-200 group-[.active]:fill-orange-200"
                      ></path>
                    </g>
                  </svg>
                  <span>All Users</span>
                </NavLink>
              </li>
              <li className="text-[16px] leading-normal font-medium">
                <NavLink
                  to={"/agencies"}
                  className={({ isActive }) =>
                    isActive
                      ? "flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all bg-gradient-to-r from-orange-300 to-orange-200"
                      : "group flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all hover:bg-white hover:text-orange-200"
                  }
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_227_4138)">
                      <path
                        d="M10.3126 15C10.082 14.9997 9.8596 14.9145 9.68792 14.7605C9.51624 14.6066 9.40731 14.3948 9.38194 14.1656C9.32627 13.706 9.10421 13.2827 8.75772 12.9757C8.41122 12.6686 7.96429 12.4991 7.50132 12.4991C7.03836 12.4991 6.59142 12.6686 6.24492 12.9757C5.89843 13.2827 5.67637 13.706 5.6207 14.1656C5.59334 14.4128 5.46894 14.6389 5.27484 14.7944C5.08074 14.9498 4.83284 15.0217 4.5857 14.9944C4.33855 14.967 4.11239 14.8426 3.95696 14.6485C3.80154 14.4544 3.72959 14.2065 3.75695 13.9594C3.86326 13.0409 4.30349 12.1935 4.99388 11.5784C5.68427 10.9633 6.57667 10.6234 7.50132 10.6234C8.42597 10.6234 9.31837 10.9633 10.0088 11.5784C10.6992 12.1935 11.1394 13.0409 11.2457 13.9594C11.2592 14.0818 11.2486 14.2056 11.2142 14.3238C11.1799 14.4421 11.1227 14.5524 11.0457 14.6485C10.9687 14.7446 10.8736 14.8247 10.7657 14.884C10.6578 14.9433 10.5393 14.9808 10.4169 14.9944C10.3823 14.9981 10.3474 15 10.3126 15ZM14.1669 9.36938C14.2893 9.35584 14.4078 9.31833 14.5157 9.25899C14.6236 9.19965 14.7187 9.11964 14.7957 9.02353C14.8727 8.92742 14.9299 8.81709 14.9642 8.69885C14.9986 8.5806 15.0092 8.45675 14.9957 8.33438C14.9242 7.4571 14.5368 6.63557 13.9054 6.02233C13.274 5.4091 12.4416 5.04583 11.5626 5C11.3139 5 11.0755 5.09877 10.8997 5.27459C10.7238 5.4504 10.6251 5.68886 10.6251 5.9375C10.6251 6.18614 10.7238 6.4246 10.8997 6.60041C11.0755 6.77623 11.3139 6.875 11.5626 6.875C11.9786 6.92256 12.3644 7.11593 12.6515 7.42084C12.9385 7.72574 13.1083 8.12246 13.1307 8.54063C13.1561 8.77002 13.2652 8.98199 13.4371 9.13594C13.6091 9.2899 13.8318 9.37502 14.0626 9.375C14.097 9.37495 14.1314 9.37308 14.1657 9.36938H14.1669ZM1.86945 8.54063C1.89185 8.12246 2.06163 7.72574 2.34869 7.42084C2.63574 7.11593 3.02151 6.92256 3.43757 6.875C3.68621 6.875 3.92467 6.77623 4.10048 6.60041C4.2763 6.4246 4.37507 6.18614 4.37507 5.9375C4.37507 5.68886 4.2763 5.4504 4.10048 5.27459C3.92467 5.09877 3.68621 5 3.43757 5C2.5588 5.04613 1.72662 5.40952 1.09548 6.02273C0.464343 6.63593 0.0771234 7.4573 0.00569543 8.33438C-0.00785572 8.45675 0.00283188 8.5806 0.0371479 8.69885C0.071464 8.81709 0.128736 8.92742 0.205694 9.02353C0.282652 9.11964 0.377789 9.19965 0.485671 9.25899C0.593552 9.31833 0.712067 9.35584 0.834445 9.36938C0.868697 9.37308 0.90312 9.37495 0.93757 9.375C1.16837 9.37502 1.39106 9.2899 1.563 9.13594C1.73495 8.98199 1.84406 8.77002 1.86945 8.54063ZM7.54819 10C7.98084 10 8.40377 9.87171 8.7635 9.63134C9.12324 9.39098 9.40361 9.04933 9.56918 8.64962C9.73475 8.24991 9.77807 7.81007 9.69366 7.38574C9.60926 6.96141 9.40092 6.57163 9.09499 6.26571C8.78906 5.95978 8.39929 5.75144 7.97496 5.66703C7.55062 5.58263 7.11079 5.62595 6.71108 5.79151C6.31136 5.95708 5.96972 6.23746 5.72936 6.59719C5.48899 6.95692 5.36069 7.37985 5.36069 7.8125C5.36069 8.39266 5.59116 8.94906 6.0014 9.3593C6.41163 9.76953 6.96803 10 7.54819 10ZM11.2982 4.375C11.7308 4.375 12.1538 4.24671 12.5135 4.00634C12.8732 3.76598 13.1536 3.42433 13.3192 3.02462C13.4847 2.62491 13.5281 2.18507 13.4437 1.76074C13.3593 1.33641 13.1509 0.946632 12.845 0.640705C12.5391 0.334778 12.1493 0.126438 11.725 0.0420332C11.3006 -0.042372 10.8608 0.000947826 10.4611 0.166515C10.0614 0.332081 9.71972 0.612459 9.47936 0.972191C9.23899 1.33192 9.11069 1.75485 9.11069 2.1875C9.11069 2.47477 9.16728 2.75922 9.27721 3.02462C9.38714 3.29002 9.54827 3.53117 9.7514 3.7343C9.95453 3.93743 10.1957 4.09856 10.4611 4.20849C10.7265 4.31842 11.0109 4.375 11.2982 4.375ZM3.7982 4.375C4.23084 4.375 4.65377 4.24671 5.0135 4.00634C5.37324 3.76598 5.65361 3.42433 5.81918 3.02462C5.98475 2.62491 6.02807 2.18507 5.94366 1.76074C5.85926 1.33641 5.65092 0.946632 5.34499 0.640705C5.03906 0.334778 4.64929 0.126438 4.22496 0.0420332C3.80062 -0.042372 3.36079 0.000947826 2.96108 0.166515C2.56136 0.332081 2.21972 0.612459 1.97936 0.972191C1.73899 1.33192 1.6107 1.75485 1.6107 2.1875C1.6107 2.76766 1.84116 3.32406 2.2514 3.7343C2.45453 3.93743 2.69568 4.09856 2.96108 4.20849C3.22648 4.31842 3.51093 4.375 3.7982 4.375Z"
                        fill="white"
                        className="group-hover:fill-orange-200"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_227_4138">
                        <rect width="15" height="15" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span>Agencies</span>
                </NavLink>
              </li>
            </>
          )}
        </ul>
      </div>

      <div className="px-5 py-[25px] border-t border-[#2B4657] h-24">
        <NavLink
          to="/settings"
          className={({ isActive }) =>
            isActive
              ? "flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all bg-gradient-to-r from-orange-300 to-orange-200"
              : "group flex items-center gap-x-[15px] px-5 py-[9px] text-white rounded-[10px] transition-all hover:bg-white hover:text-orange-200"
          }
        >
          <svg
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_954_415)">
              <path
                d="M6.68751 2.14059C6.17613 1.05327 4.88013 0.58639 3.79283 1.09777C3.33439 1.31339 2.96561 1.68218 2.75001 2.14059H0.9375C0.419736 2.14059 0 2.56033 0 3.07809C0 3.59585 0.419736 4.01559 0.9375 4.01559H2.74688C3.25825 5.10291 4.55426 5.56979 5.64155 5.05841C6.09996 4.84282 6.46875 4.474 6.68438 4.01559H14.0625C14.5803 4.01559 15 3.59585 15 3.07809C15 2.56033 14.5803 2.14059 14.0625 2.14059H6.68751Z"
                fill="white"
                className="group-hover:fill-orange-200 group-[.active]:fill-orange-200"
              />
              <path
                d="M10.2844 5.8125C9.44165 5.81399 8.67507 6.30056 8.31501 7.06251H0.9375C0.419736 7.06251 0 7.48225 0 8.00001C0 8.51777 0.419736 8.93751 0.9375 8.93751H8.31249C8.82387 10.0248 10.1199 10.4917 11.2072 9.98033C11.6656 9.76474 12.0344 9.39592 12.25 8.93751H14.0625C14.5803 8.93751 15 8.51777 15 8.00001C15 7.48225 14.5803 7.06251 14.0625 7.06251H12.2531C11.8932 6.30076 11.1269 5.81426 10.2844 5.8125Z"
                fill="white"
                className="group-hover:fill-orange-200 group-[.active]:fill-orange-200"
              />
              <path
                d="M4.71563 10.7344C3.87311 10.7361 3.10685 11.2226 2.74688 11.9844H0.9375C0.419736 11.9844 0 12.4041 0 12.9219C0 13.4396 0.419736 13.8594 0.9375 13.8594H2.74688C3.25825 14.9467 4.55426 15.4136 5.64155 14.9022C6.09996 14.6866 6.46875 14.3178 6.68438 13.8594H14.0625C14.5803 13.8594 15 13.4396 15 12.9219C15 12.4041 14.5803 11.9844 14.0625 11.9844H6.68751C6.32704 11.2216 5.55926 10.7349 4.71563 10.7344Z"
                fill="white"
                className="group-hover:fill-orange-200 group-[.active]:fill-orange-200"
              />
            </g>
            <defs>
              <clipPath id="clip0_954_415">
                <rect
                  width="15"
                  height="15"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>

          <span>Account Settings</span>
        </NavLink>
      </div>
    </aside>
  );
};
export default Sidebar;
